import { c as _c } from "react/compiler-runtime";
import { AnalyticsBarChart } from "@components/analytics/analytics-bar-chart";
import { Box } from "@mui-wrapper";
import { chartsDataSelector, fetchingAnalyticsFlagsSelector, visibleChartTypesSelector } from "@store/analytics/analytics-selector";
import { useAppSelector } from "@store/store-helper";

/** Margin to have in between charts */
export const ANALYTICS_CHART_MARGIN = "14px";

/** Renders analytics stats data as charts */
export function AnalyticsCharts() {
  const $ = _c(14);
  const data = useAppSelector(chartsDataSelector);
  const {
    isFetchingCompanyStats: isLoading
  } = useAppSelector(fetchingAnalyticsFlagsSelector);
  const numberOfSkeletons = useAppSelector(visibleChartTypesSelector).length;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
      marginTop: ANALYTICS_CHART_MARGIN
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== isLoading || $[2] !== numberOfSkeletons) {
    t1 = isLoading && [...Array(numberOfSkeletons)].map((_, index) => <AnalyticsBarChart key={index} shouldShowSkeleton={true} isFullWidth={numberOfSkeletons === 1} />);
    $[1] = isLoading;
    $[2] = numberOfSkeletons;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== data || $[5] !== isLoading) {
    t2 = !isLoading && data?.length > 0 && data.map((chartData, index_0) => <AnalyticsBarChart key={index_0} data={chartData} isFullWidth={data.length === 1} />);
    $[4] = data;
    $[5] = isLoading;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== data?.length || $[8] !== isLoading) {
    t3 = !isLoading && !data?.length && <>No analytics charts to display</>;
    $[7] = data?.length;
    $[8] = isLoading;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3) {
    t4 = <Box component="div" sx={t0}>{t1}{t2}{t3}</Box>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}